<template>
    <div class="flex flex-col w-full justify-center gap-8 mb-6">

        <div
            class="bg-white flex flex-col gap-6 w-full px-8 py-6 rounded-md h-auto ring-1 ring-[#E9ECEE] hover:ring-[#D3D9DC] hover:shadow">

            <div class=" flex flex-row w-full items-start justify-between ">
                <div class="info h-36 w-min flex gap-6 flex-col ">
                    <h5 class="cb-text-h4">
                        {{msg}}
                    </h5>


                    <div class="flex gap-3">

                        <!-- This example requires Tailwind CSS v2.0+ -->
                        <nav aria-label="Progress">
                            <ol role="list" class="flex align-top gap-8">
                                <!-- Complete Step -->
                                <li>
                                    <a href="#steps" class="group">
                                        <span class="flex items-start gap-2">
                                            <span
                                                class="flex-shrink-0 relative h-5 w-5 flex items-center justify-center">
                                                <!-- Heroicon name: solid/check-circle -->
                                                <svg class="h-full w-full text-[#012A38] group-hover:text-[#012A38]"
                                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" aria-hidden="true">
                                                    <path fill-rule="evenodd"
                                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                                        clip-rule="evenodd"></path>
                                                </svg>
                                            </span>
                                            <span class="flex min-w-0 w-max max-w-[224px]  flex-col">
                                                <span
                                                    class=" cb-text-copy-regular text-neutral-400 font-medium">Configuration
                                                    Done</span>
                                                <span class=" cb-text-copy-small  text-gray-500">Your business
                                                    information has been submitted.</span>
                                            </span>
                                        </span>
                                    </a>
                                </li>

                                <!-- Current Step -->
                                <li>
                                    <a href="#steps" class="flex items-start" aria-current="step">
                                        <div class="flex items-start gap-2">
                                            <span
                                                class="flex-shrink-0 h-5 w-5 relative flex items-center justify-center"
                                                aria-hidden="true">
                                                <span class="absolute h-4 w-4 rounded-full bg-brand-100"></span>
                                                <span class="relative block w-2 h-2 bg-brand-400 rounded-full"></span>
                                            </span>
                                            <span class="flex min-w-0 w-max max-w-[224px]  flex-col">
                                                <span class=" cb-text-copy-regular font-medium text-brand-600">Under
                                                    Review</span>
                                                <span class=" cb-text-copy-small text-brand-600">We are processing
                                                    your
                                                    application. Check back for more updates</span>
                                            </span>
                                        </div>

                                    </a>
                                </li>

                                <!-- Complete Under review Step - hidden default -->
                                <li>
                                    <a href="#steps" class="group hidden">
                                        <span class="flex items-start gap-2">
                                            <span
                                                class="flex-shrink-0 relative h-5 w-5 flex items-center justify-center">
                                                <!-- Heroicon name: solid/check-circle -->
                                                <svg class="h-full w-full text-[#012A38] group-hover:text-[#012A38]"
                                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" aria-hidden="true">
                                                    <path fill-rule="evenodd"
                                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                                        clip-rule="evenodd"></path>
                                                </svg>
                                            </span>
                                            <span class="flex min-w-0 w-max max-w-[224px]  flex-col">
                                                <span class=" cb-text-copy-regular text-neutral-400 font-medium">Application
                                                    Reviewed</span>
                                                <span class=" cb-text-copy-small  text-gray-500">We are processing
                                                    your
                                                    application. Check back for more updates</span>
                                            </span>
                                        </span>
                                    </a>
                                </li>

                                <!-- Upcoming Step -->
                                <li>
                                    <a href="#steps" class="group">
                                        <div class="flex items-start">
                                            <div class="flex-shrink-0 h-5 w-5 relative flex items-center justify-center"
                                                aria-hidden="true">
                                                <div class="h-2 w-2 bg-[#D3D9DC] rounded-full group-hover:bg-[#012A38]">
                                                </div>
                                            </div>
                                            <span class="flex min-w-0 w-max max-w-[224px]  flex-col">
                                                <span class=" cb-text-copy-regular text-neutral-400 font-medium">Go
                                                    Live</span>
                                                <span class=" cb-text-copy-small  text-neutral-400">Ready to accept
                                                    payments.</span>
                                                <button
                                                    class="mt-2 hidden inter antialiased text-[14.22px] font-semibold leading-[18.48px] text-[#2F3A3F] underline underline-offset-2 focus:rounded-sm focus:outline-none focus:ring-1 focus:ring-offset-2 focus:ring-offset-[#E9ECEE] focus:ring-[#011922]">Configure
                                                    Payment Routes</button>

                                            </span>
                                        </div>
                                    </a>
                                </li>

                                <!-- Final complete Step - hidden default -->
                                <li>
                                    <a href="#steps" class="flex items-start hidden" aria-current="step">
                                        <div class="flex items-start gap-2">
                                            <span
                                                class="flex-shrink-0 h-5 w-5 relative flex items-center justify-center"
                                                aria-hidden="true">
                                                <span class="absolute h-4 w-4 rounded-full bg-brand-100"></span>
                                                <span class="relative block w-2 h-2 bg-brand-400 rounded-full"></span>
                                            </span>
                                            <span class="flex min-w-0 w-max max-w-[224px]  flex-col">
                                                <span class=" cb-text-copy-regular font-medium text-brand-600">Go
                                                    Live</span>
                                                <span class=" cb-text-copy-small text-brand-600">Ready to accept
                                                    payments.</span>
                                                    <button
                                                    class="mt-2 inter antialiased text-[14.22px] font-semibold leading-[18.48px] text-[#2F3A3F] underline underline-offset-2 focus:rounded-sm focus:outline-none focus:ring-1 focus:ring-offset-2 focus:ring-offset-[#E9ECEE] focus:ring-[#011922]">Configure
                                                    Payment Routes</button>
                                            </span>
                                        </div>

                                    </a>
                                </li>

                                

                                
                            </ol>
                        </nav>


                    </div>



                </div>


                <div>
                    <img class=" w-full " src="../assets/TrackingIllustration.svg">
                </div>
            </div>
            <!-- <Transition>
                
                        <div class="w-full rounded bg-[#E9ECEE] p-4">
                      <div class="flex">
                        <div class="flex-shrink-0">

                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-[#3F4E54]" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
                          </svg>
                        </div>
                        <div class="ml-3 w-full flex items-center justify-between">
                          <div class="inter antialiased text-[14.22px] font-normal leading-[18.48px] text-[#20272A]">
                            <p>Configure rules that can help Chargebee pick the right gateway account when your customer adds their payment method.</p>
                          </div>
                          <button class="mx-[3px] inter antialiased text-[14.22px] font-semibold leading-[18.48px] text-[#2F3A3F] underline underline-offset-2 focus:rounded-sm focus:outline-none focus:ring-1 focus:ring-offset-2 focus:ring-offset-[#E9ECEE] focus:ring-[#011922]">Configure Payment Routes</button>
                        </div>
                      </div>
                    </div>
            </Transition> -->


        </div>

    </div>
</template>

<script>

export default {
    name: 'BannerStepper',
    data() {
        return {
            showOption: false,
            step1: false,
            step2: false,
            // msg: "Your application is under review. Check back soon."
            msg: "We are reviewing your application. This normally takes 24 hours"
        }
    },
    methods: {
        getUnits: function () {
            console.log("works");
        }
    },
    beforeMount() {
        setTimeout(() => {
            this.step1 = true
        }, 1000);

        setTimeout(() => {
            this.step2 = true
            // this.msg = "Chargebee Payments is Live! "
        }, 2000);
    }
}

</script>